import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

// Tempo de produção do setor (dono, 25/09/2026). Em branco = segue os tempos
// de Sistema → Preferências. 0 = o produto já entra PRONTO no KDS (bebida de
// freezer: o garçom só pega). Maior que o vermelho de Preferências = o cartão
// com esse produto demora mais pra ficar amarelo/vermelho.

/** "" (vazio) → null; "0" → 0; texto inválido → null. */
export function tempoParaSalvar(valor) {
  const txt = String(valor ?? "").trim();
  if (txt === "") return null;
  const n = parseInt(txt, 10);
  return Number.isFinite(n) && n >= 0 ? Math.min(n, 600) : null;
}

/** Selo do setor na lista: "entra pronto" (0) ou "40 min". */
export function rotuloTempoSetor(setor) {
  const t = setor?.tempo_producao;
  if (t == null || t === "") return null;
  return Number(t) === 0 ? "entra pronto" : `${t} min`;
}

export default function CampoTempoProducao({ valor, onChange }) {
  const t = tempoParaSalvar(valor);
  return (
    <div>
      <Label htmlFor="setor-tempo">Tempo de produção (minutos)</Label>
      <Input
        id="setor-tempo" type="number" min={0} max={600} inputMode="numeric"
        value={valor} onChange={(e) => onChange(e.target.value.replace(/[^\d]/g, ""))}
        placeholder="Em branco = tempos de Preferências" className="mt-1" data-e2e="setor-tempo"
      />
      <p className="text-xs text-muted-foreground mt-1.5 leading-snug">
        {t === 0
          ? "0 = o produto deste setor já entra PRONTO no KDS (ex.: bebida de freezer, o garçom só pega). Pedido só com produtos assim vai direto pra Prontos."
          : t != null
            ? `Se for maior que o tempo do vermelho em Sistema → Preferências, o cartão com produto deste setor só fica vermelho depois de ${t} min (o amarelo cresce junto). Menor, vale Preferências.`
            : "Deixe em branco para usar os tempos de Sistema → Preferências. Use 0 para produto que já está pronto (freezer) ou um tempo maior para produto mais demorado."}
      </p>
    </div>
  );
}
